import { officeAgendaForOrigin } from '../server/office-agendas';

// A server redirect chain also works for Ctrl-click / opening a link in a new
// tab. Cookies remain HttpOnly and scoped to each Office host.
export function officeLink(value: string): string {
  const url = new URL(value, location.origin);
  if (!officeAgendaForOrigin(location.origin) || !officeAgendaForOrigin(url.origin) || url.origin === location.origin) return value;
  return `/api/auth/navigate?to=${encodeURIComponent(url.toString())}`;
}
